import { __rest, __read, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useState } from 'react';
import FocusLock from 'react-focus-lock';
import { useRect } from '@reach/rect';
import { Box } from '../Box/index.js';
import { renderProp } from '../utils/renderProp.js';
import { Popover } from '../Popover/Popover.js';
import { positionMatchWidth } from '../Popover/usePopover.js';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { useUpdateEffect } from '../hooks/useUpdateEffect/index.js';
import { useDropdownContent } from './useDropdownContent.js';

var DropdownContent = function DropdownContent(_a) {
    var children = _a.children, _b = _a.position, position = _b === void 0 ? positionMatchWidth : _b, onKeyDown = _a.onKeyDown, onBlur = _a.onBlur, onDismiss = _a.onDismiss, _c = _a.autoFocus, autoFocus = _c === void 0 ? true : _c, focusLockProps = _a.focusLockProps, portal = _a.portal, sx = _a.sx, props = __rest(_a, ["children", "position", "onKeyDown", "onBlur", "onDismiss", "autoFocus", "focusLockProps", "portal", "sx"]);
    var _d = useDropdownContent({
        onKeyDown: onKeyDown,
        onBlur: onBlur,
    }), context = _d.context, contentProps = _d.props;
    var popoverRef = context.popoverRef, triggerRef = context.triggerRef, anchorRef = context.anchorRef, isOpen = context.isOpen;
    var _e = __read(useState(isOpen), 2), enableFocusLock = _e[0], setEnableFocusLock = _e[1];
    var popoverRect = useRect(popoverRef, { observe: isOpen });
    var handleStyleProps = useTheme().handleStyleProps;
    var popoverStyles = handleStyleProps({ sx: sx }, { baseStyle: { minWidth: "fit-content" } }).css;
    var content = renderProp({ prop: children, context: context });
    // Ensures the popover is expanded before the Focus Lock toggle
    // This is to stop unwanted scrolling to a portal that is hidden at the bottom of DOM
    useUpdateEffect(function () {
        if (autoFocus && (popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current)) {
            if ((popoverRect === null || popoverRect === void 0 ? void 0 : popoverRect.x) !== 0 && (popoverRect === null || popoverRect === void 0 ? void 0 : popoverRect.y) !== 0) {
                setEnableFocusLock(isOpen);
            }
        }
    }, [popoverRect, isOpen]);
    useUpdateEffect(function () {
        !isOpen && onDismiss && onDismiss();
    }, [isOpen]);
    var focusLockEnabled = autoFocus ? enableFocusLock : isOpen;
    return (jsx(Popover
    // hidden instead of removing if `isOpen: false`
    , __assign({ 
        // hidden instead of removing if `isOpen: false`
        hidden: !isOpen, ref: popoverRef, targetRef: triggerRef, anchorRef: anchorRef, position: position, portal: portal, css: popoverStyles }, { children: jsx(FocusLock, __assign({ returnFocus: true, autoFocus: autoFocus, disabled: !focusLockEnabled }, focusLockProps, { children: jsx(Box, __assign({ "data-autofocus-inside": true }, props, contentProps, { children: content })) })) })));
};

export { DropdownContent };
//# sourceMappingURL=DropdownContent.js.map
